export default __webpack_public_path__ + "static/media/taskRequest.0d5679ba.svg";